import React, { useEffect, useState } from 'react';
import { Button, Modal, InputGroup} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import { Typeahead } from 'react-bootstrap-typeahead';

import 'react-toastify/dist/ReactToastify.css';
import Field from '../../Wizard/Field/Field';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';

import moment from 'moment';

import './EditPersonModal.scss';

function EditPersonModal(props) {
    const auth = useAuth();
    const t = useTranslate();  
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const myRef = React.useRef<any>();

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });
    const [editPerson, setEditPerson] = useState({
        lastname: "",
        firstname: "",
        organization: "",
        email: "",
        phone: "",
        description: "",
    } as any);

    const [autoCompleteOptions, setAutoCompleteOptions] = useState<Array<any>>([]);

    const [shownMessage, setShownMessage] = useState<string>("");

    const setEditPersonLastName = value => { setEditPerson(editPerson => ({...editPerson, lastname: value})); }
    const setEditPersonFirstName = value => { setEditPerson(editPerson => ({...editPerson, firstname: value})); }
    const setEditPersonOrganization = value => { setEditPerson(editPerson => ({...editPerson, organization: value})); }
    const setEditPersonEmail = value => { setEditPerson(editPerson => ({...editPerson, email: value})); }
    const setEditPersonPhone = value => { setEditPerson(editPerson => ({...editPerson, phone: value})); }
    const setEditPersonDescription = value => { setEditPerson(editPerson => ({...editPerson, description: value})); }

    function clearForm(){
        setEditPerson(undefined);

    }

    function handleEditPerson() {
        if (editPerson["lastname"] == "") { notifyWarning(t("people.toast_people_empty_name")); return undefined; }
        if (editPerson["email"] !== "undefined" ) {
            let pattern = new RegExp(/^$|^([\w\.\-]+)@([\w\-]+)((\.(\w){2,})+)$/);
            if (!pattern.test(editPerson["email"])) {
                notifyWarning(t("people.toast_people_invalidemail"));
                return undefined;
            }
        }
        axios.put(
            "/api/persons/" + editPerson["_id"],
            {
                lastname: editPerson["lastname"],
                firstname: editPerson["firstname"],
                email: editPerson["email"],
                organization: editPerson["organization"],
                phone: editPerson["phone"],
                description: editPerson["description"],
            },
            {
                headers: {'x-access-token': auth.user["token"]}
            }
        ).then(res => {
            if (props.onSaveEdit != undefined) props.onSaveEdit();
            fetchData();
            notifySuccess(t("people.toast_people_updated"));
            clearForm();
        });
    }

    const newPersonOrganizationChange = (value) => {
        /*if (value.length > 1) {
            axios.all([
                axios.single({
                    method: "post",
                    url: "/api/customers/search/org",
                    data: {
                        filter: value
                    },
                    responseType: "json",
                    headers: { 'x-access-token': auth.user["token"] }
                })
            ]).then(axios.spread((...res) => {
                    let orgOptionsList: Array<any> = [];
                    let autoCompleteOptionsList: Array<any> = [];
                    let customersOrgOptions = res[0].data;
                    customersOrgOptions.forEach((customer) => {
                        if(!orgOptionsList.map(i => i.organizationName).includes(customer.organizationName)){
                            orgOptionsList.push(customer);
                            autoCompleteOptionsList.push({ id: customer._id, label: customer.organizationName, data: customer });
                        } 
                    });
                    setAutoCompleteOptions(autoCompleteOptionsList);
                }))
                .catch(err => console.log(err));
        }*/
        setEditPersonOrganization(value);
    };
    
    async function fetchData() {
        if (props.personId != undefined) {
            axios.all([
                axios.single({
                    method: "get",
                    url: "/api/persons/" + props.personId,
                    responseType: "json",
                    headers: {'x-access-token': auth.user["token"]}
                }),
                axios.single({
                    method: "get",
                    url: "/api/customers/",
                    responseType: "json",
                    headers: {'x-access-token': auth.user["token"]}
                }),
            ])
            .then(axios.spread((...res) => {
                setEditPerson(res[0].data);

                let autoCompleteOptionsList: Array<any> = [];
                res[1].data.forEach((customer) => {
                    autoCompleteOptionsList.push({
                        id: customer._id,
                        label: customer.organizationName != undefined && customer.organizationName != "" ? customer.organizationName : (customer.lastname + " " + customer.firstname),
                        data: customer
                    });
                });
                setAutoCompleteOptions(autoCompleteOptionsList);
            }));
        }
    }

    const handleOnExited = () => {
        setEditPerson(undefined);
    }

    useEffect(() => {
        fetchData();
    }, [props.show, props.personId, props.org]);

    return (
        <Modal size="lg" show={props.show} onExited={handleOnExited} onHide={() => { if(props.onHide != undefined) props.onHide(); }}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {t("people.edit")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className={ editPerson?.communications?.length > 0 ? "col col-md-6" : "col col-md-12"}>
                        <Field
                            type="input"
                            title={t("people.lastname")}
                            value={editPerson != undefined ? editPerson["lastname"] : ""}
                            onChange={value => setEditPersonLastName(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={t("people.firstname")}
                            value={editPerson != undefined ? editPerson["firstname"] : ""}
                            onChange={value => setEditPersonFirstName(value)}
                        ></Field>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("people.organization")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Typeahead
                                id="newPersonOrganizationInput"
                                onInputChange={newPersonOrganizationChange}
                                className="typeaheadinput"
                                onChange={items => {
                                    if (items.length > 0) {
                                        newPersonOrganizationChange(items[0]["label"])
                                    } else return null;
                                }}

                                //onKeyDown={handleKeyDownPersonCreate}
                                ref={myRef}
                                minLength={2}
                                emptyLabel={t("persons.no_results")}
                                options={autoCompleteOptions} 
                                defaultInputValue={props.org}
                            />
                        </InputGroup>
                        <Field
                            type="input"
                            title={t("people.email")}
                            value={editPerson != undefined ? editPerson["email"] : ""}
                            onChange={value => setEditPersonEmail(value)}
                        ></Field>
                        <Field
                            type="input"
                            title={t("people.phone")}
                            value={editPerson != undefined ? editPerson["phone"] : ""}
                            onChange={value => setEditPersonPhone(value)}
                        ></Field>
                        <Field
                            type="textarea"
                            title={t("people.description")}
                            value={editPerson != undefined ? editPerson["description"] : ""}
                            onChange={value => setEditPersonDescription(value)}
                        ></Field>
                    </div>
                    { editPerson?.communications?.length > 0 ?
                        <div className={ editPerson?.communications?.length > 0 ? "col col-md-6" : "col col-md-12"}>
                            <p>{t("people.communicationlog.title")}</p>
                            <div className="communicationlog">
                                { (editPerson?.communications ?? []).map((communication, key) => 
                                    <div key={key} className="communication" onClick={() => {
                                        if (shownMessage != communication["date"])
                                            setShownMessage(communication["date"]);
                                        else
                                            setShownMessage("");
                                    }}>
                                        <p className="date">{moment(communication["date"]).format("DD.MM.yyyy HH:mm")}</p>
                                        <div className="top">
                                            <p className="left">{communication["type"]}<br/>{communication["to"]}</p>
                                        </div>
                                        <div className={"middle " + (shownMessage == communication["date"] ? "" : "hidden")}>
                                            <p>{communication["subject"]}</p>
                                            <p dangerouslySetInnerHTML={{ __html: communication["message"].replaceAll("\n", "<br/>")}}></p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    : null}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => { if(props.onCancel != undefined) props.onCancel(); }}>
                    {t("people.cancel")}
                </Button>
                <Button onClick={handleEditPerson}>
                    {t("people.save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
 
export default EditPersonModal; 